'use client'

import Image from "next/image"
import Link from "next/link"

export function SiteFooter() {
  return (
    <footer className="bg-white border-t border-gray-400 p-8">

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 max-w-7xl mx-auto   ">

        <div className=" space-y-2">
          <span className="text-lg font-black tracking-wide  text-blue-800">
            OrgoneNX
            <p className=' font-semibold  text-sm text-gray-500 mt-5'>The single window portal for all operational and organizational requirements at Creative Proptech driving precision in every process.</p>
          </span>
        </div>


        <div className="space-y-2 text-center">
          <label className="font-black ">Explore</label>
          <div className="space-y-2 flex flex-col font-semibold text-gray-500  text-xs mt-5">
            <Link href="#"><label className="text-sm text-gray-500">Culture  Guide</label></Link>
            <Link href="#"><label className="text-sm text-gray-500">Carrier Hub</label></Link>
            <Link href="#"><label className="text-sm text-gray-500">Perks & Benefits</label></Link>
          </div>
        </div>


        <div className="space-y-2 text-center">
          <label className="font-black  ">Support </label>
          <div className="space-y-2 flex flex-col font-semibold text-gray-500  text-xs mt-5 ">
            <Link href="#"><label className="text-sm text-gray-500">Hr Help Desk</label></Link>
            <Link href="#"><label className="text-sm text-gray-500">IT Help Desk</label></Link>
            <Link href="#"><label className="text-sm text-gray-500">Compliance Portal</label></Link>
          </div>
        </div>


      </div>

    </footer>
  )
}